module.exports = __webpack_public_path__ + "static/media/audio2.a61801e8.mp3";